/* eslint-disable @typescript-eslint/no-explicit-any */
import { createKey, Key } from "./utils/createKey";

export type CacheKey = Key;
export type CacheValue = any;

export const cache = new Map();

export const setCache = (_key: CacheKey, value: CacheValue) => {
    const key = createKey(_key);
    cache.set(key, value);
};

export const getCache = (_key: CacheKey) => {
    const key = createKey(_key);
    return cache.get(key);
};

export const deleteCache = (_key: CacheKey) => {
    const key = createKey(_key);
    return cache.delete(key);
};
